<img [src]="imageSrc" alt="Refund Image" style="width: 100%; height: auto;" />
